<template>
  <div class="app">
    <div class="wrapbg">
      <div class="wrap">
        <span id="logpc" class="logo" />
        <div class="diqiu">
          <!-- <span class="renwu" /> -->
          <span class="slogan" />
          <span class="time">
            活动时间：{{ start_date }} - {{ end_date }}
          </span>
        </div>

        <span class="topnav">
          <a href="/" target="_blank">进入官网</a>
          |
          <a href="/download.shtml" class="ios" target="_blank">游戏下载</a>
          <a href="/download.shtml" class="android" target="_blank">游戏下载</a>
        </span>

        <div class="dajpk-lg">

          <p v-show="dlhv" id="dlh">

            <span class="bz" /> 账号：{{ ga_account }} <span v-if="role_name!==''">角色名：{{ role_name }}</span> <a href="javascript:;" class="loyout" @click="loYout()">退出</a><br>
          </p>
          <p v-show="dlqv" id="dlq">
            欢迎您，请先 <a href="javascript:;" class="denglubtn" @click="dengLubtn()">登录</a>
          </p>
          <a href="javascript:;" class="listbtn" @click="listbtn()">&nbsp;</a>

        </div>
        <div class="niaodan" @click="tcs('dben')" />
        <Cj :islog="islog" :start-login="startLogin" :cfg-act-status="cfgActStatus" :cfg-act-status-msg="cfgActStatusMsg" />
        <Guize :final-url="finalUrl" />
      </div>
    </div>
    <Popups ref="Popups" :islog="islog" :start-login="startLogin" :final-url="finalUrl" :recording-list="recordingList" :select-sever="selectSever" :rolebd="rolebd" />
    <Loading v-show="show" />
    <div v-show="hpbgShow" class="hp-bg" />
  </div>
</template>
<script>

// import { mapState } from 'vuex';
import fetchApi from '../api/api';
import tccMixins from '../api/tccMixins';
import Mztapi, { $$ } from '../tools/utils';

import Loading from '../components/Loading.vue';
import Cj from '../components/Cj';
import Guize from '../components/Guize';
import Popups from '../components/Popups.vue';

import '@babel/polyfill';

let Ajax = {
  get: function(url, fn) {
    // XMLHttpRequest对象用于在后台与服务器交换数据
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, false);
    xhr.onreadystatechange = function() {
      // readyState == 4说明请求已完成
      if (xhr.readyState === 4) {
        if (xhr.status === 200 || xhr.status === 304) {
          fn.call(xhr.responseText);
        }
      }
    }
    xhr.send();
  },

  // data应为'a=a1&b=b1'这种字符串格式，在jq里如果data为对象会自动将对象转成这种字符串格式
  post: function(url, data, fn) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', url, false);
    // 添加http头，发送信息至服务器时内容编码类型
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        if (xhr.status === 200 || xhr.status === 304) {
          fn.call(xhr.responseText);
        }
      }
    }
    xhr.send(data);
  }
}

function work() {
  onmessage = ({ data: { message }}) => {
    let lukyPerson2 = [];
    for (var i = 0; i < 1e3 + 6; i++) {
      lukyPerson2.push({ who: '186****5564', name: '典藏画册' + i });
    }
    lukyPerson2.push({ who: '186****5564', name: '结束222' });
    postMessage({ result: lukyPerson2 });
  };
}

const runWorker = f => {
  const worker = new Worker(
    URL.createObjectURL(new Blob([`(${f.toString()})()`]))
  );

  worker.onmessage = ({ data: { result }}) => {
  };

  worker.postMessage({ message: 'message from main thread' });
};

let wxdz = 0;
let runWx = '';
export default {
  components: {
    Popups,
    Loading,
    Cj,
    Guize
  },
  filters: {
    g(value) {
      // {{(.+?)}}
      let pp = /(\|)/g;
      return value.replace(pp, function(a, b) {
        return '\n';
      })
    }
  },
  mixins: [
    tccMixins
  ],
  provide() {
    return {
      // provide 只支持对象属性的监听 如：{a:1}，直接变量赋值不能被改变a:1
      test: this.protest,
      canyu_counts: this.canyu_counts,
      cnt: this.cnt
    }
  },
  data() {
    return {
      canyu_counts: {
        a: 0
      },
      protest: {
        a: 0
      },
      cnt: {
        a: 0
      },
      startLogin: null,
      show: false,
      hpbgShow: false,
      dlhv: false,
      dlqv: true,
      islog: 0, // 判断是否登录 0 ,1
      finalUrl: '/act/carnival_2020/api/index.php?act=',

      ga_account: 0, // 账号名称
      ga_accountID: 0, // 账号id
      is_closed: 0, // 活动结束标识 0=未结束 1=已结束
      rolebd: '', // 账号是否已绑定

      wxtitle: '嘉年华全民抽奖，永久时装幸运宝箱大瓜分！',
      wxdesc: '《征途2手游》全民共庆嘉年华，登录账号即可参与抽奖！超值大奖等你来拿！',
      wximages: '',

      zone_name: '', //	string 	绑定的服务器
      role_name: '', //	绑定的角色
      score: '', //	积分总数
      chance: '', 	// 剩余抽奖机会

      recordingList: [], // 奖品列表
      selectSever: [], // 基础配置 服务器列表

      start_date: '',
      end_date: '',

      cfgActStatus: 0, // 活动是否结束
      cfgActStatusMsg: '' // 活动结束提示文字
    };
  },
  computed: {

    // ...mapState({

    // })
  },
  mounted() {
    const _this = this;

    _this.islog = 0;
    var sprt = {
      imgs: [

      ]
    }
    if (Mztapi.device.any()) {
      sprt.imgs = [
        require('../images/caidai.png'),
        require('../images/rays-main.png'),
        require('../images/bz.png'),
        require('../images/logo.png'),
        require('../images/time.png'),
        require('../images/slogan.png'),
        require('../images/home.png')
      ]
    } else {
      sprt.imgs = [
        require('../images/caidai.png'),
        require('../images/home_m.png'),
        require('../images/rays-main.png'),
        require('../images/bgm.jpg'),
        require('../images/logo.png'),
        require('../images/time_m.png'),
        require('../images/slogan_m.png')
      ]
    }

    let LoadImgs = new Mztapi.LoadImg();

    let dom = document.documentElement || document.body;
    dom.addEventListener('touchstart', () => {
      if (Mztapi.device.any() && _this.islog === 1 && wxdz === 0) {
        runWx.wxshare({
          url: _this.minviteurl,
          title: _this.wxtitle,
          desc: _this.wxdesc,
          images: _this.wximages
        });
        wxdz = 1;
      }
    })

    _this.$nextTick(() => {
      LoadImgs.loadImages(sprt.imgs, 'fbs', async function() {
        $$('#loadingbg').style.display = 'none';

        Mztapi.addClassName($$('.wrapbg'), 'on');

        requirejs(['jquery', 'share/share', 'login/index', 'downloadway/main'], function($, ztshare, gLogin, Download) {
          _this.startLogin = new gLogin({
            zc: '',
            return_url: window.location.href,
            login_type: 30, // 手机验证码登陆
            // login_type: 27, // 账号密码登陆
            onLogin: function(result, fromCookie, fromReg) {
              if (!!result && !!result.account) {
              // closetcs();
                _this.ga_account = result.showaccount;
                _this.getUserInfo();
              } else {
                alert(result.msg);
              }
            },
            onInit: function() {
              fetchApi({
                url: _this.finalUrl + 'getcfg',
                type: 'get',
                success: (res) => {
                  _this.cnt.a = res.cnt;
                  _this.start_date = res.start_date;
                  _this.end_date = res.end_date;
                }
              });
            },
            onLogout: function(result) {
              if (!!result && !!result.status && result.status > 0) {
                _this.islog = 0;

                _this.dlhv = false;
                _this.dlqv = true;
                Mztapi.removeClassName($$('.loyout'), 'on');
                _this.ga_account = '';
              } else {
                alert(result.msg);
              }
            }
          });

          // 下载
          new Download({
            iosBtn: $('.ios'),
            androidBtn: $('.android'),
            // qrcode: $('.qrcode'),
            display: 'inline-block',
            tip: '敬请期待',
            callback: function(info) {

            }
          });

          let image = require('../images/share.jpg');

          // var metaimage = document.createElement('meta');
          // metaimage.setAttribute('content', '//' + window.location.host + image);
          // metaimage.setAttribute('itemprop', 'image');
          // document.querySelector('head').appendChild(metaimage);

          _this.minviteurl = 'https://' + window.location.host + '/act/carnival_2020/';
          _this.wximages = 'https://' + window.location.host + image;
          runWx = new ztshare({
            url: _this.minviteurl,
            title: _this.wxtitle,
            desc: _this.wxdesc,
            images: _this.wximages,
            phone: {
              dataUrl: _this.minviteurl,
              success: function() {
              },
              cancel: function() {
              }
            }
          })
        })
        //
      })
    })
  },
  methods: {
    // 获取用户信息
    async getUserInfo() {
      // const testWorker = runWorker(work);
      await fetchApi({
        url: this.finalUrl + 'getinfo',
        type: 'get',
        success: (res) => {
          if (res.force_logout === 1) {
            this.loYout();
            return false;
          }
          if (res.status === 1) {
            let result = res.user_info;
            this.dlhv = true;
            this.dlqv = false;

            this.islog = 1;

            // this.ga_account = result.ga_account;
            this.role_name = result.role_name;
            this.zone_name = result.zone_name;
            this.rolebd = result.role_id;

            this.recordingList = result.choujiang_log;

            this.minviteurl = result.share_url;

            if (Mztapi.device.any()) {
              runWx.wxshare({
                url: this.minviteurl,
                title: this.wxtitle,
                desc: this.wxdesc,
                images: this.wximages
              });
            }

            // localStorage.setItem('cok', 1);
          } else if (res.status === -20) {
            this.islog = 0;
            this.dlhv = false;
            this.dlqv = true;
          }
        }
      });

      await fetchApi({
        url: this.finalUrl + 'getcfg',
        type: 'get',
        success: (res) => {
          if (res.cfg_act_status === 1) {
            this.selectSever = res.cfg_zone_list;
          }
          this.cfgActStatus = res.cfg_act_status;
          this.cfgActStatusMsg = res.cfg_act_status_msg;
        }
      });
    },
    // 更新列表信息
    async getInfo() {
      // const testWorker = runWorker(work);
      await fetchApi({
        url: this.finalUrl + 'getinfo',
        type: 'get',
        success: (res) => {
          if (res.force_logout === 1) {
            this.loYout();
            return false;
          }
          if (res.status === 1) {
            let result = res.user_info;
            this.role_name = result.role_name;
            this.zone_name = result.zone_name;
            this.rolebd = result.role_id;

            this.recordingList = result.choujiang_log;

            this.minviteurl = result.share_url;
          }
        }
      });
    },
    // 登录
    dengLubtn() {
      if (this.cfgActStatus === 0 && this.islog === 1) {
        alert(this.cfgActStatusMsg);
        return false;
      }
      this.startLogin.login('popup', function(result) {
        return true;
      });
    },
    // 退出
    loYout() {
      this.islog = 0;
      this.startLogin.logout();
      // window.location.reload();
    },
    // 礼包列表List
    async list() {
      let _this = this;
      await fetchApi({
        url: this.finalUrl + 'a=awardlist',
        type: 'get',
        success: function(res) {
          if (res.status === 1) {
            _this.listAry = res.list;
          } else {
            alert(res.msg)
          }
        }
      });
    },
    addcountsBtn() {
      if (this.islog === 0) {
        this.startLogin.login('popup', function(result) {
          return true;
        });
        return false;
      }
    },
    msgclose(id) {
      event.stopPropagation(); // 阻止了事件冒泡，但不会阻击默认行为
      event.preventDefault(); // 阻止默认事件

      Mztapi.removeClassName($$('.cover'), 'on');
      Mztapi.removeClassName($$('#' + id), 'on');
    },
    // 获奖记录
    listbtn() {
      if (this.cfgActStatus === 0 && this.islog === 1) {
        alert(this.cfgActStatusMsg);
        return false;
      }
      if (this.islog === 0) {
        this.startLogin.login('popup', function(result) {
          return true;
        });
        return false;
      }
      this.getInfo();
      this.tcs('list', () => {

      });
    }

  }
};
</script>
